module.exports = __webpack_public_path__ + "static/img/flopmachine_en.02bd51c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/flopmachine_en.png
// module id = 6WkA
// module chunks = 1